<div class="container  app__component">
    <h1 class="heading">
        <ng-container i18n>Order line fields</ng-container>
        <small *ngIf="loading && orderFields" class="text-muted" i18n>Loading...</small>
    </h1>

    <app-loader *ngIf="!orderFields" class="text-muted" i18n>Loading...</app-loader>

    <p *ngIf="orderFields">
        <a class="btn  btn-primary  button  button--add-to-table" href="javascript:" (click)="add()" i18n>Add order line field</a>
    </p>

    <app-table *ngIf="orderFields" [autoSizeLastColumn]="true">
        <thead>
        <tr>
            <th i18n>Name</th>
            <th style="width: 60px;"></th>
        </tr>
        </thead>

        <tbody>
        <ng-template ngFor let-orderField [ngForOf]="orderFields" let-i="index">
            <tr>
                <td>
                    <fa-icon [ngbTooltip]="'Localizations missing'" *ngIf="!missingLocalizations[i].complete" [icon]="faExclamation"></fa-icon>
                    {{ orderField.name }}
                    <span class="badge  badge-secondary" style="transform: translateY(-1px);">{{ orderField.type }}</span>
                </td>
                <td class="text-right">
                    <a href="javascript:" (click)="edit(orderField, i)" i18n>Edit</a>
                    <a href="javascript:" (click)="delete(orderField)" class="text-danger" i18n>Delete</a>
                </td>
            </tr>
        </ng-template>
        </tbody>
    </app-table>
</div>
